import { Link } from "react-router-dom";
import { CardBody, Input, Label, TabContent, TabPane } from "reactstrap";
import { BuySellSectionBodyPropsType } from "../../../../Type/Dashboard/CryptoDashboardType";
import { BuyNow, SellCoins } from "../../../../utils/Constant";

const BuySellSectionBody = ({id}:BuySellSectionBodyPropsType) => {
  return (
    <CardBody className="pt-0">
      <TabContent activeTab={id}>
        <TabPane tabId="1">
          <div className="from-buy mb-4">
            <Label> Volume:</Label>
            <Input type="text" placeholder="Min 0.001" id="money"/>
          </div>
          <div className="from-buy price-content">
            <Label> Price:</Label>
            <Input type="text" placeholder="$7487,385" id="money1"/>
          </div>
          <div className="from-buy amount">
            <Label> Amount:</Label>
            <Input type="text" placeholder="Buy Amount" id="money2"/>
          </div>
          <Link className="btn btn-primary" to={`${process.env.PUBLIC_URL}/ecommerce/pricing`}>
            {BuyNow}
          </Link>
        </TabPane>
        <TabPane tabId="2">
          <div className="from-buy mb-4">
            <Label> Volume:</Label>
            <Input type="text" placeholder="Min 0.001" id="money3"/>
          </div>
          <div className="from-buy price-content">
            <Label> Price:</Label>
            <Input type="text" placeholder="$7487,385" id="money4" />
          </div>
          <div className="from-buy amount">
            <Label> Amount:</Label>
            <Input type="text" placeholder="Buy Amount" id="money5" />
          </div>
          <Link className="btn btn-primary" to={`${process.env.PUBLIC_URL}/ecommerce/pricing`}>
            {SellCoins}
          </Link>
        </TabPane>
      </TabContent>
    </CardBody>
  );
};

export default BuySellSectionBody;
